const Tracking = {
  path: "",
  name: "",
  redirect: "/transfers-tracking",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/transfers-tracking",
      redirect: "/transfers-tracking",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Tracking",
      meta: {
        requiresAuth: true,
        activeUrl: "/transfers-tracking",
        parent: "/transfers-tracking",
        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/tracking"),
          meta: {
            requiresAuth: true,
            activeUrl: "/transfers-tracking",
            parent: "/transfers-tracking",
            lv: 2,
          },
        },
        {
          path: "log/:id",
          name: "Tracking Log",
          component: () => import("@/views/pages/tracking/detail"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/transfers-tracking",
            parent: "/transfers-tracking",
            lv: 3,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Tracking;
